<template>
  <v-row>
    <v-col cols="12">
      <v-card>
        <v-data-iterator
          :items="items"
          :loading="fetching"
          :items-per-page="items_per_page"
          :page.sync="current_page"
          :server-items-length="items_total"
          :single-expand="true"
          item-key="uuid"
        >
          <template v-slot:header>
            <v-card-actions>
              <form @submit.prevent="fetch">
                <v-text-field
                  label="Search"
                  solo
                  dense
                  flat
                  clearable
                  hide-details
                  prepend-inner-icon="mdi-magnify"
                  v-model="query"
                  @click:prepend-inner="fetch"
                  @click:clear="
                    () => {
                      query = null;
                      fetch();
                    }
                  "
                  :loading="fetching"
                ></v-text-field>
              </form>
              <v-divider vertical></v-divider>
              <v-select
                v-model="role"
                @change="fetch"
                solo
                dense
                flat
                hide-details
                :items="choices_role"
                item-text="text"
                item-value="value"
                label="Role"
              ></v-select>
              <v-divider vertical></v-divider>
              <v-select
                v-model="order_by"
                @change="fetch"
                solo
                dense
                flat
                hide-details
                :items="choices_order"
                item-text="text"
                item-value="value"
                label="Sort by"
              ></v-select>
              <v-divider vertical></v-divider>
              <v-btn
                icon
                depressed
                @click="
                  () => {
                    dir = dir == 'asc' ? 'desc' : 'asc';
                    fetch();
                  }
                "
              >
                <v-icon>{{ dir == 'asc' ? 'mdi-arrow-up' : 'mdi-arrow-down' }}</v-icon>
              </v-btn>
            </v-card-actions>
            <v-divider></v-divider>
          </template>
          <template v-slot:no-data>
            <v-row align="center" justify="center">
              <div class="py-5">No data</div>
            </v-row>
          </template>
          <template v-slot:default="{ items, select, isSelected, expand, isExpanded }">
            <v-list>
              <template v-for="(item, index) in items">
                <user-item
                  @ban="lockUser"
                  @unban="unlockUser"
                  @show="show"
                  :key="item.uuid"
                  v-bind="item"
                />
                <v-divider :key="index"></v-divider>
              </template>
            </v-list>
          </template>
        </v-data-iterator>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import { mapFields, mapMultiRowFields } from "vuex-map-fields";
import UserItem from "../../components/users/UserItem";
export default {
  components: {
    "user-item": UserItem
  },
  computed: {
    ...mapState("users", {
      fetching: "fetching",
      pagination: "pagination",
      instance: "instance",
      choices: "choices"
    }),

    ...mapGetters("users", {
      items: "items"
    }),
    ...mapFields("users", {
      query: "query.q",
      page: "query.page",
      order_by: "query.order_by",
      dir: "query.dir",
      role: "query.role"
    }),
    choices_order: function() {
      return this.choices.order;
    },
    choices_role: function() {
      return this.choices.role;
    },
    items_per_page: function() {
      return _.get(this.pagination, "per_page", 15);
    },
    last_page: function() {
      return _.get(this.pagination, "last_page", 1);
    },
    current_page: {
      get: function() {
        return _.get(this.pagination, "current_page", 1);
      },
      set: function(page) {
        this.page = page;
        this.fetch();
      }
    },
    items_total: {
      get: function() {
        return _.get(this.pagination, "total", 0);
      },
      set: function(value) {
        return;
      }
    }
  },
  methods: {
    ...mapActions("users", {
      fetch: "fetch",
      lock: "lock",
      unlock: "unlock"
    }),
    lockUser(uuid) {
      this.lock(uuid).then(() => this.fetch());
    },
    unlockUser(uuid) {
      this.unlock(uuid).then(() => this.fetch());
    },
    show(uuid) {
      this.$router.push({ name: "users.show", params: { uuid } });
    }
  },

  mounted() {
    this.fetch();
  }
};
</script>

<style lang="scss" scoped></style>
